export const getIsItemNew = (itemsArray: any[], itemId: number) => {
  return !itemsArray.some((item) => item.READONLY_ID === itemId);
}
